import {Component, OnInit, ViewChild, OnDestroy} from '@angular/core';
import {RegistriesService} from '../../service';
import {TableReactiveUrlController} from '@amlCore/tableReactive';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {AlertPanelComponent, AlertService} from '@amlCore/components';
import {DictInfo} from '../../model';
import {AccessJson} from '@amlCore/models';
import {CheckDictEnum, RegistriesAccessEnum} from '@amlCore/enums';
import {Utils} from '@amlCore/utils';
import {
  ResourceService,
  TableService,
  UserService,
  VisitedService
} from '@amlCore/services';


@Component({
  selector: 'app-registry-mass-lead-info',
  templateUrl: './massLeadInfo.component.html'
})
export class MassLeadInfoComponent extends TableReactiveUrlController implements OnInit, OnDestroy {

  isShowVisited = true;
  public loadCheckList = {};
  @ViewChild('alertObjCheck', {static: false}) alertObjToCheck: AlertPanelComponent;

  constructor(private regSrv: RegistriesService,
              private resourceSrv: ResourceService,
              private userSrv: UserService,
              private alertSrv: AlertService,
              protected activatedRoute: ActivatedRoute,
              protected visitedService: VisitedService,
              protected tableService: TableService,
              protected router: Router) {
    super(router, activatedRoute, visitedService, tableService, {pageSize: 20, sort: 'uploaded', dir: 'DESC'});
  }

  public massLeadInfoEntries: Array<DictInfo> = [];
  public access: AccessJson;
  placeholder = 'Поиск по ФИО, наименованию, ИНН';
  ngOnInit() {
    this.access = this.userSrv.getAccess(RegistriesAccessEnum.QREF_MSLEAD);
    this.activatedRoute.queryParams.subscribe(data => {
      this.loadList(this.syncParams(data));
    });
  }

  public onPageChange(params) {
    this.navigate(this.getParams(params));
  }

  public loadList(params?: any) {
    const queryParams = this.getParams(params);
    this.resourceSrv.getMassLeadInfo(queryParams).subscribe(data => {
      this.massLeadInfoEntries = data.content;
      this.total = data.totalElements;
      this.scrollRun();
    });
  }

  public edit(msLead: DictInfo) {
    this.tableService.saveScrollPosition(this.commonKeyStore);
    this.router.navigate(['registries/massLeadSubject', msLead.id]);
  }

  /**
   * @override
   */
  public onSearch() {
    const queryParams = this.getSearchPage(this.filter);
    queryParams["sort"] = "firstName";
    queryParams["dir"] = "ASC";
    this.tableService.saveScrollPosition(this.commonKeyStore);
    this.router.navigate(['registries/massLeadInfoAll'], {
      queryParams: {q: Utils.encodeJSONBase64(queryParams)} as Params
    });
  }

  public remove(confirm, massLead: DictInfo) {
    this.alertSrv.clear();
    this.regSrv.removeFile('/api/v1/qref/mslead/remove', {id: massLead.id}).subscribe(data => {
      this.alertSrv.success(`Запись ${massLead.name} удалена!`);
      this.loadList();
    });
  }

  /**
   * Проверка по факторам риска
   * @param item - элемент проверки
   */
  public checkRiskFactor(item: DictInfo) {
    this.regSrv.doCheckRiskFactor(item, CheckDictEnum.MSLEAD, this.loadCheckList, this.alertObjToCheck);
  }

  /**
   * метод получения объекта плоского фильтра
   * @param data объект фильтра с полями
   */
  public getFilterObject(data) {
    const filter = this.tableService.getFilterSubject(data);
    return this.getFilterPlanObject(filter);
  }

  ngOnDestroy() {
    this.checkScrollOptions();
  }

}
